import { z } from "zod"

export const creditCardSchema = z.object({
  number: z
    .string()
    .min(13, "Número do cartão inválido")
    .max(19, "Número do cartão inválido")
    .regex(/^\d+$/, "Apenas números"),
  holderName: z.string().min(3, "Nome do titular é obrigatório"),
  expMonth: z.string().regex(/^(0[1-9]|1[0-2])$/, "Mês inválido"),
  expYear: z
    .string()
    .regex(/^\d{2,4}$/, "Ano inválido")
    .transform(v => (v.length === 2 ? `20${v}` : v)),
  cvv: z.string().min(3, "CVV inválido").max(4, "CVV inválido").regex(/^\d+$/, "Apenas números"),
})

export type CreditCardFormData = z.infer<typeof creditCardSchema>

export const customerInfoSchema = z.object({
  name: z.string().min(3, "Nome é obrigatório"),
  email: z.string().email("Email inválido"),
  document: z
    .string()
    .min(11, "CPF inválido")
    .max(14, "CPF/CNPJ inválido")
    .regex(/^[\d.-]+$/, "Apenas números, pontos e traços"),
  phone: z.string().optional(),
})

export type CustomerInfoFormData = z.infer<typeof customerInfoSchema>
